import { getEfficiencies } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
import { isEmpty } from 'lodash';

export const useGetEfficiencies = (tenantId: string, enabled = true) => {
  const { data, status } = useQuery(
    ['efficiencies', tenantId],
    () => getEfficiencies(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    data: data || [],
    status: status,
  };
};
